import React from 'react';
import { Activity, Server, AlertTriangle, Database } from 'lucide-react';
import { Card } from '../components/ui/Primitives';
export function SystemMonitoring() {
  return <div className="max-w-[1600px] mx-auto space-y-6" data-id="element-902">
      <div className="mb-6" data-id="element-903">
        <h1 className="text-xl font-semibold text-slate-900" data-id="element-904">
          System Monitoring
        </h1>
        <p className="text-sm text-slate-500" data-id="element-905">
          DevOps observability and infrastructure health.
        </p>
      </div>

      <div className="grid grid-cols-5 gap-4" data-id="element-906">
        <MetricCard title="Memory Usage" value="42%" icon={<Server className="w-4 h-4" data-id="element-908" />} data-id="element-907" />
        <MetricCard title="Cache Hit Rate" value="94.2%" icon={<Database className="w-4 h-4" data-id="element-910" />} data-id="element-909" />
        <MetricCard title="Queue Throughput" value="124/s" icon={<Activity className="w-4 h-4" data-id="element-912" />} data-id="element-911" />
        <MetricCard title="Error Rate" value="0.12%" icon={<AlertTriangle className="w-4 h-4 text-amber-500" data-id="element-914" />} data-id="element-913" />
        <MetricCard title="Async Apex Depth" value="12" icon={<Activity className="w-4 h-4" data-id="element-916" />} data-id="element-915" />
      </div>

      <div className="grid grid-cols-2 gap-6" data-id="element-917">
        <Card className="p-5 h-64 flex flex-col" data-id="element-918">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-919">
            Event Ingestion Rate
          </h2>
          <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 flex items-center justify-center text-slate-400 text-sm" data-id="element-920">
            [Area Chart: Ingestion by Source]
          </div>
        </Card>
        <Card className="p-5 h-64 flex flex-col" data-id="element-921">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-922">
            Error Rate Trend
          </h2>
          <div className="flex-1 bg-slate-50 rounded-lg border border-slate-100 flex items-center justify-center text-slate-400 text-sm" data-id="element-923">
            [Line Chart: Error Rate with Threshold]
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-3 gap-6" data-id="element-924">
        <Card className="p-5" data-id="element-925">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-926">
            Dead-letter Queue
          </h2>
          <div className="space-y-4" data-id="element-927">
            <DlqRow system="Bonzo" count={42} data-id="element-928" />
            <DlqRow system="GHL" count={128} data-id="element-929" />
            <DlqRow system="Five9" count={0} data-id="element-930" />
          </div>
        </Card>
        <Card className="p-5" data-id="element-931">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-932">
            Loop Guard
          </h2>
          <div className="text-3xl font-bold text-emerald-600 font-mono mb-2" data-id="element-933">
            1,492
          </div>
          <div className="text-xs text-slate-500" data-id="element-934">
            Infinite loops prevented today. This is a good thing.
          </div>
        </Card>
        <Card className="p-5" data-id="element-935">
          <h2 className="text-sm font-semibold text-slate-800 mb-4" data-id="element-936">
            Deduplication
          </h2>
          <div className="text-3xl font-bold text-slate-700 font-mono mb-2" data-id="element-937">
            8,234
          </div>
          <div className="text-xs text-slate-500" data-id="element-938">
            Duplicate events dropped (15m window).
          </div>
        </Card>
      </div>
    </div>;
}
function MetricCard({
  title,
  value,
  icon
}: any) {
  return <Card className="p-4" data-id="element-939">
      <div className="flex items-center justify-between mb-2" data-id="element-940">
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-941">
          {title}
        </div>
        <div className="text-slate-400" data-id="element-942">{icon}</div>
      </div>
      <div className="text-2xl font-bold text-slate-900 font-mono" data-id="element-943">{value}</div>
    </Card>;
}
function DlqRow({
  system,
  count
}: any) {
  return <div className="flex items-center justify-between" data-id="element-944">
      <span className="text-sm font-medium text-slate-700" data-id="element-945">{system}</span>
      <div className="flex items-center gap-3" data-id="element-946">
        <span className={`text-sm font-mono ${count > 0 ? 'text-red-500 font-bold' : 'text-slate-400'}`} data-id="element-947">
          {count}
        </span>
        {count > 0 && <button className="text-xs text-electric-600 hover:underline" data-id="element-948">
            Reprocess
          </button>}
      </div>
    </div>;
}